module.exports = __webpack_public_path__ + "static/img/logo.31ee06b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo.png
// module id = 210
// module chunks = 56